import { moduleProviderFactory } from 'core/providers';
import { RoleList } from 'modules/role/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.role',
				pattern: '/roles',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.role.list',
						pattern: '',
						component: RoleList,
						authorization: ['roleMenuSection.full'],
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/role/config.js